<div class="row">

  <div class="col-md-11">
    <div mat-dialog-content>
      <span>{{data.messageText}}</span>
    </div>
  </div>
  <div class="col-md-1">
    <div mat-dialog-actions>
      <button mat-icon-button >Fechar
      </button>

    </div>
  </div>

</div>